import React from "react";

interface FleetrifyDumButtonProp {
  label: string;
  onClick: () => void;
}

const angleRight = (
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.85449 1.40625L6.91699 6.46875L1.85449 11.5312"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FleetrifyDumButton = ({ label, onClick }: FleetrifyDumButtonProp) => {
  return (
    <button
      onClick={onClick}
      className="flex gap-4 transition-all border border-[#143887CC] !p-2 !px-4 duration-300 items-center bg-[#F5F6FA] py-[5px] rounded-[16px] group"
    >
      <p className="text-[#333333] text-xs">{label}</p>
      <figure className="group-hover:translate-x-1 transition-all duration-500 ">
        {angleRight}
      </figure>
    </button>
  );
};

export default FleetrifyDumButton;
